enum PackageCreatingResultType {
  Success = 1,
  AnotherPackageProcessed = 2,
}

export default PackageCreatingResultType;